// extracted by mini-css-extract-plugin
export default {"hyperlink":"EditorExtension_AlbumLink_hyperlink__EqM6Y"};